import {
  MediaSize,
  ReviewSubmissionConfig as IReviewSubmissionConfig
} from 'services/api-service'

export class ReviewSubmissionConfig implements IReviewSubmissionConfig {
  constructor(config: IReviewSubmissionConfig) {
    this.deviceFingerprintOn = config.deviceFingerprintOn
    this.mediaSizes = config.mediaSizes
    this.recommendRequired = config.recommendRequired
    this.showRecommend = config.showRecommend
    this.showSweepstakes = config.showSweepstakes
    this.textMinLength = config.textMinLength
    this.textMaxLength = config.textMaxLength
    this.textRequired = config.textRequired
    this.titleMaxLength = config.titleMaxLength
    this.titleRequired = config.titleRequired
  }

  deviceFingerprintOn: boolean
  mediaSizes: Array<MediaSize>
  recommendRequired: boolean
  showRecommend: boolean
  showSweepstakes: boolean
  textMinLength: number
  textMaxLength: number
  textRequired: boolean
  titleMaxLength: number
  titleRequired: boolean
}

let defaultConfig: IReviewSubmissionConfig = {}
export function loadConfig(config: IReviewSubmissionConfig) {
  defaultConfig = new ReviewSubmissionConfig(config)
}
export { defaultConfig as default }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/submission/review-submission.config.ts